
export const config = {
  // URLs de la API
  api: {
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 10000
  },

  // Configuración de autenticación
  auth: {
    tokenKey: 'auth_token',
    userKey: 'auth_user',
    tokenExpiration: 24 * 60 * 60 * 1000 // 24 horas en milisegundos
  },

  // Configuración de paginación
  pagination: {
    defaultLimit: 10,
    maxLimit: 100
  },

  // Configuración de archivos
  files: {
    maxSize: 5 * 1024 * 1024, // 5MB
    allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    allowedDocumentTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  },

  // Configuración de la aplicación
  app: {
    name: 'Panel de Administración de Mascotas',
    version: '1.0.0',
    description: 'Sistema de gestión para clínica veterinaria'
  },

  // Configuración de validación
  validation: {
    password: {
      minLength: 8,
      requireUppercase: true,
      requireLowercase: true,
      requireNumbers: true,
      requireSpecialChars: false
    },
    email: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    }
  },

  // Configuración de notificaciones
  notifications: {
    timeout: 5000,
    position: 'top-right' as const
  }
}

export default config